import React from 'react'



export default function Loading() {
    return (
        <div>
            <div>
                <img src='https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/b6e0b072897469.5bf6e79950d23.gif' />
            </div>
        </div>
    )
}